// extracted by mini-css-extract-plugin
module.exports = {"termsConditions":"TermsCard_termsConditions__3_kUG"};